import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  AddOrganizationModalAction,
  hideAddOrganizationModal,
  showAddOrganizationModal,
  submitAddOrganizationForm,
} from './actions'
import { AddOrganizationModalState } from './types'

export const addOrganizationModalReducer = combineReducers<AddOrganizationModalState, AddOrganizationModalAction>({
  show: (show = false, action) => {
    switch (action.type) {
      case getType(showAddOrganizationModal):
        return true
      case getType(hideAddOrganizationModal):
      case getType(submitAddOrganizationForm):
        return false
      default:
        return show
    }
  },
  submitting: (submitting = false, action) => {
    switch (action.type) {
      case getType(submitAddOrganizationForm):
        return true
      case getType(showAddOrganizationModal):
      case getType(hideAddOrganizationModal):
        return false
      default:
        return submitting
    }
  },
})
